/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_TitleInputs */

const en_rental_booking_title = /** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book Your Stay`)
};

const es_rental_booking_title = /** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva Tu Estancia`)
};

const fr_rental_booking_title = /** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez votre séjour`)
};

const de_rental_booking_title = /** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buche deinen Aufenthalt`)
};

const id_rental_booking_title = /** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Penginapan Anda`)
};

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const ja_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const zh_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const ar_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const it_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const ru_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const pt_rental_booking_title = en_rental_booking_title;

/** @type {(inputs: Rental_Booking_TitleInputs) => LocalizedString} */
const ko_rental_booking_title = en_rental_booking_title;

/**
* | output |
* | --- |
* | "Book Your Stay" |
*
* @param {Rental_Booking_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_title = /** @type {((inputs?: Rental_Booking_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_title(inputs)
	if (locale === "es") return es_rental_booking_title(inputs)
	if (locale === "fr") return fr_rental_booking_title(inputs)
	if (locale === "de") return de_rental_booking_title(inputs)
	if (locale === "ja") return ja_rental_booking_title(inputs)
	if (locale === "zh") return zh_rental_booking_title(inputs)
	if (locale === "ar") return ar_rental_booking_title(inputs)
	if (locale === "id") return id_rental_booking_title(inputs)
	if (locale === "it") return it_rental_booking_title(inputs)
	if (locale === "ru") return ru_rental_booking_title(inputs)
	if (locale === "pt") return pt_rental_booking_title(inputs)
	return ko_rental_booking_title(inputs)
});